import PageDrawer from './index.vue'

PageDrawer.install = Vue => {
  Vue.component(PageDrawer.name, PageDrawer)
}

export default PageDrawer



// WEBPACK FOOTER //
// ./src/components/page-drawer/index.js